module.exports = __webpack_public_path__ + "static/img/qrcode.287dc8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode.png
// module id = /4D4
// module chunks = 1